import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const r = {
  display: "block"
}, f = ({ size: e = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: m, style: d, ...p }) => {
  const h = d ? { ...r, ...d } : r;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-xianhuodingdan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ç°è´§è®¢å"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.1 7.732A3.632 3.632 0 0 1 7.732 4.1h14.345a3.632 3.632 0 0 1 3.632 3.632V10.5a.9.9 0 1 1-1.8 0V7.732c0-1.012-.82-1.832-1.832-1.832H7.732C6.72 5.9 5.9 6.72 5.9 7.732v16.394c0 1.012.82 1.832 1.832 1.832h5.83a.9.9 0 0 1 0 1.8h-5.83A3.632 3.632 0 0 1 4.1 24.126V7.732Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.654 11.375a.9.9 0 0 1 .9-.9h9.107a.9.9 0 1 1 0 1.8H9.554a.9.9 0 0 1-.9-.9Zm0 5.465a.9.9 0 0 1 .9-.9h5.464a.9.9 0 0 1 0 1.8H9.554a.9.9 0 0 1-.9-.9Zm15.831-1.64a.9.9 0 0 1 .538 1.153l-.242.666 1.043.38a2.91 2.91 0 0 1-1.99 5.47l-5.759-2.096 1.515-4.162a1.392 1.392 0 0 1 1.784-.832l1.715.624.242-.666a.9.9 0 0 1 1.154-.538Zm-3.343 2.41-.76 2.087 4.067 1.48a1.11 1.11 0 1 0 .76-2.087l-4.067-1.48Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M20.015 27.47a.9.9 0 0 0 1.154-.538l.242-.665 1.044.38a2.91 2.91 0 1 0 1.99-5.47l-5.757-2.097-1.515 4.162c-.263.723.11 1.522.832 1.785l1.715.624-.243.666a.9.9 0 0 0 .538 1.153Zm-1.011-3.995.76-2.088 4.066 1.48a1.11 1.11 0 1 1-.76 2.088l-4.066-1.48Z"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
